{
  "SET_NEW_PASSWORD": {
    "TITLE": "Atur kata sandi baru",
    "PASSWORD": {
      "LABEL": "Kata Sandi",
      "PLACEHOLDER": "Kata Sandi",
      "ERROR": "Kata sandi terlalu pendek."
    },
    "CONFIRM_PASSWORD": {
      "LABEL": "Konfirmasi kata sandi",
      "PLACEHOLDER": "Konfirmasi Kata Sandi",
      "ERROR": "Kata Sandi tidak cocok."
    },
    "API": {
      "SUCCESS_MESSAGE": "Berhasil mengubah kata sandi.",
      "ERROR_MESSAGE": "Tidak dapat terhubung ke Server Woot, Silahkan coba lagi nanti"
    },
    "CAPTCHA": {
      "ERROR": "Verifikasi telah kedaluwarsa. Silakan selesaikan captcha kembali."
    },
    "SUBMIT": "Kirim"
  }
}
